import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { PatientVaccineSettings } from '../../../interfaces/masters/patientvaccinesettings';


@Injectable()
export class PatientVaccineSettingsApi {
    private readonly apiController: string = 'patientvaccinesettings';

    constructor(private api: HttpService) { } 

    list(url: string, options?: any): Observable<PatientVaccineSettings> {      
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        //header.append('Content-Type', 'applications/json');
        //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        //header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }

     

      create(url:string, data: PatientVaccineSettings):Observable<PatientVaccineSettings>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        // const formData: FormData = new FormData();
        // formData.append('Image', data.photo);
        // data.photo = formData;
        return this.api.post( url, data, header);
      }  
}
